import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./routes.mjs";
import componentMap from "./componentMap";

export default function Routers() {
  return (
    <Routes>
      {routes.map((route, index) => {
        if (route?.redirect) {
          return (
            <Route
              key={index}
              path={route.path}
              element={<Navigate to={route?.redirect} replace />}
            />
          );
        }

        const Component = componentMap[route.component];
        return (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            element={<Component />}
          />
        );
      })}
    </Routes>
  );
}
